import * as React from 'react';
import { createFileRoute, Link, Outlet, useNavigate } from '@tanstack/react-router';
import { NavigationMenu, NavigationMenuList, NavigationMenuLink, NavigationMenuItem } from '@/components/atoms/navigation-menu';
import type { UserState } from '@/types';
import { handleLogout } from '@/components/helpers/accountHelpers';
import { Alert, AlertDescription } from '@/components/atoms/alert';

export const Route = createFileRoute('/account')({
  component: Account,
});

declare global {
  interface Window {
    __user__: UserState
  }
}
function Account() {
  const navigate = useNavigate();

  // Using useEffect to ensure this only runs on the client and not the server.
  React.useEffect(() => {
    const user = window.__user__;
    if(user) {
      if(!user.isLoggedIn) {
        navigate({ to: '/my-account'});
      }
    }
  }, []);

  return(
    <div className="main-content">
      <div className="flex flex-row gap-3">
        <div className="account-menu-item">
          <Link to="/account/home" className="text-sm">Account Home</Link>
        </div>
        <div className="account-menu-item">
          <Link to="/account/saved-quotes" className="text-sm">My Quotes</Link>
        </div>
        <div className="account-menu-item">
          <Link to="/account/orders" className="text-sm">My Orders</Link>
        </div>
        <div className="account-menu-item">
          <Link to="/logout" className="text-sm">Log Out</Link>
        </div>
      </div>
      <Outlet />
    </div>
  )
}
